import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'slash', 'Slash', [["path",{"d":"M17 5l-10 14"}]]);